'use strict';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));
var _ = require('lodash');
var FaresOptimizerWebFareChartTransformationService = function FaresOptimizerWebFareChartTransformationService($filter, FaresOptimizerConstants, momentService) {
  var MIN_LENGTH_OF_RECORD = 6;
  var rmMomentFormat = $filter('rmMomentFormat');
  function transformWebFareData(title, data, selectedLowestWebFare) {
    var webFareDetails = [];
    _.map(data, function (details) {
      _.map(details, function (detail) {
        var plotFare = checkWhichFareToPlot(selectedLowestWebFare, detail);
        var plotFareOccurence = checkWhichFareOccurenceToPlot(selectedLowestWebFare, detail);
        webFareDetails.push({
          title: title,
          departureDate: rmMomentFormat(momentService.of(detail.departureDate, momentService.TYPE.LOCAL_DATE), momentService.DATE_USER_SETTINGS),
          dateToSort: detail.departureDate,
          baseFare: detail.baseFare,
          totalFare: detail.totalFare,
          fareToPlot: plotFare,
          visible: detail.visible !== undefined ? detail.visible : true,
          connectionOutbound: detail.connectionOutbound || 'N/A',
          lowestFareOccurence: plotFareOccurence,
          lowestBaseFarePercentage: detail.lowestBaseFarePercentage,
          lowestTotalFarePercentage: detail.lowestTotalFarePercentage,
          fareComponents: detail.toolTipContent.fareComponents,
          fareTotal: detail.toolTipContent.fareTotal
        });
      });
    });
    return webFareDetails;
  }
  function checkWhichFareToPlot(selectedLowestWebFare, detail) {
    return selectedLowestWebFare === FaresOptimizerConstants.WEB_FARE_LOWEST_BASE_KEY ? detail.baseFare : detail.totalFare;
  }
  function checkWhichFareOccurenceToPlot(selectedLowestWebFare, detail) {
    var lowestFareOccurence = selectedLowestWebFare === FaresOptimizerConstants.WEB_FARE_LOWEST_BASE_KEY ? detail.lowestBaseFarePercentage : detail.lowestTotalFarePercentage;
    return lowestFareOccurence ? lowestFareOccurence + '%' : 'N/A';
  }
  function getWebFaresFromDateAndCheckForTodayRecord(webFares, dateFrom, isVisible) {
    var today = dateFrom ? dateFrom : momentService.systemNow(momentService.TYPE.LOCAL_DATE);
    var afterDate = today.add(-1, 'd');
    var isExistTodayRecord = false;
    var filteredWebFares = _.filter(webFares, function (detail) {
      if (!isExistTodayRecord && detail.departureDate === today.format(today.config.format)) {
        isExistTodayRecord = true;
      }
      if (isVisible !== undefined) {
        detail.visible = isVisible;
      }
      return isAfterDate(afterDate, detail.departureDate);
    });
    return {
      filteredWebFares: filteredWebFares,
      isExistTodayRecord: isExistTodayRecord
    };
  }
  function isAfterDate(afterDate, departureDate) {
    var dateToCheck = getMomentType(departureDate);
    if (afterDate && dateToCheck) {
      return dateToCheck.isAfter(afterDate);
    }
    return false;
  }
  function getMomentType(date) {
    return (0, _typeof2["default"])(date) === 'object' ? date : momentService.of(date, momentService.TYPE.LOCAL_DATE);
  }
  function fillDummyDates(webFareDetails, isExistTodayRecord, dateFrom) {
    var today = dateFrom ? dateFrom : momentService.systemNow(momentService.TYPE.LOCAL_DATE);
    var fillUptoIndex = getMinimumLengthOfRecord();
    var lastRecordDate = getMomentType(webFareDetails[webFareDetails.length - 1].departureDate);
    var tempWebFareDetails = _.cloneDeep(webFareDetails);
    if (!isExistTodayRecord) {
      // add the current date to be plotted in the x-axis
      tempWebFareDetails.push({
        departureDate: today.format(today.config.format)
      });
    }
    for (var i = tempWebFareDetails.length; i < fillUptoIndex; i++) {
      lastRecordDate = lastRecordDate.add(1, 'd');
      tempWebFareDetails.push({
        departureDate: lastRecordDate.format(lastRecordDate.config.format)
      });
    }
    return tempWebFareDetails;
  }
  function getMinimumLengthOfRecord() {
    return MIN_LENGTH_OF_RECORD;
  }
  return {
    transformWebFareData: transformWebFareData,
    checkWhichFareToPlot: checkWhichFareToPlot,
    checkWhichFareOccurenceToPlot: checkWhichFareOccurenceToPlot,
    getWebFaresFromDateAndCheckForTodayRecord: getWebFaresFromDateAndCheckForTodayRecord,
    getMinimumLengthOfRecord: getMinimumLengthOfRecord,
    fillDummyDates: fillDummyDates
  };
};
FaresOptimizerWebFareChartTransformationService.$inject = ['$filter', 'FaresOptimizerConstants', 'MomentService'];
module.exports = FaresOptimizerWebFareChartTransformationService;